<template>
  <b-modal id="complete-modal" hide-footer :title="modalTitle" :size="isSupplementTutor ? 'lg' : 'md'" centered no-close-on-backdrop @show="initAttendanceRows" @hidden="resetDate">
    <div v-if="isCompleteMode" class="upload-box">
      <div>
        <p class="mb-1 font-weight-bold">Ảnh check-in</p>
        <p class="mb-0 text-muted">Tải lên ảnh chụp màn hình phòng Zoom trước khi hoàn thành buổi học.</p>
      </div>
      <button type="button" class="btn btn-primary" @click="openDirection()" :disabled="!!previewImage">
        <i class="el-icon-upload2"></i> Tải lên
      </button>
    </div>
    <input
        ref="input"
        type="file"
        style="display:none"
        accept="image/*"
        @change="handleFileChange"
    />
    <div v-if="previewImage && isCompleteMode" style="width: 200px; height: 150px; position: relative" class="mt-4">
      <img :src="previewImage" alt="" style="width: 100%; height: 100%; object-fit: cover">
      <i @click="handleDeleteImage" class="el-icon-circle-close delete"
         style="position: absolute; top: -13px; right: -12px; cursor: pointer;font-size: 25px"></i>
      <div class="w-100 h-100 edit"
           style="position: absolute;top: 0; display: flex; justify-content: center; align-items: center">
        <i @click="openDirection" class="el-icon-edit icon-edit"></i>
      </div>
    </div>
    <div v-if="isSupplementTutor" class="mt-5">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <p class="mb-0 font-weight-bold">Điểm danh học viên</p>
        <div v-if="isCompleteMode">
          <button type="button" class="btn btn-primary btn-sm mr-2" @click="markAll('present')">
            <i class="el-icon-check"></i> Có mặt tất cả
          </button>
          <button type="button" class="btn btn-light btn-sm" @click="markAll('absent')">
            <i class="el-icon-close"></i> Vắng tất cả
          </button>
        </div>
      </div>
      <el-table :data="attendanceRows" border size="small" style="width: 100%">
        <el-table-column type="index" label="STT" width="60" />
        <el-table-column label="Mã HV" min-width="100">
          <template slot-scope="{ row }">
            <span class="student-code">{{ row.code || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Tên học viên" min-width="180">
          <template slot-scope="{ row }">{{ row.name || '-' }}</template>
        </el-table-column>
        <el-table-column label="Trạng thái" min-width="150" align="right">
          <template slot-scope="{ row }">
            <div v-if="isViewMode">
              <span class="attendance-status" :class="row.status === 'present' ? 'present' : 'absent'">
                {{ row.status === null?'Chưa điểm danh': row.status === 'present' ? 'Có mặt' : 'Vắng' }}
              </span>
            </div>
            <div v-else class="attendance-actions">
              <button type="button" :class="['attendance-btn', { active: row.status === 'present' }]" @click="row.status = 'present'">Có mặt</button>
              <button type="button" :class="['attendance-btn', { active: row.status === 'absent' }]" @click="row.status = 'absent'">Vắng</button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" class="btn btn-secondary mr-4" @click="closeModal()">{{ isViewMode || isAttendanceEditMode ? 'Đóng' : 'Hủy' }}</button>
      <button
          v-if="!isViewMode"
          type="button"
          class="btn btn-primary"
          :disabled="disableCompleteButton"
          @click="submitAttendance"
      >
        <i v-if="loading" class="el-icon-loading"></i>{{ isAttendanceEditMode ? 'Cập nhật' : 'Hoàn thành' }}
      </button>
    </div>
  </b-modal>
</template>
<script>
import { COMPLETE_DETAIL_TUTOR_TASK } from "@/core/services/store/tutor/tutor.module";
import { COMPLETE_SUPPLEMENTARY_TUTOR_ATTENDANCE } from "@/core/services/store/tutor/tutor.module";
import { updateSupplementTutorAttendance } from "@/core/mock/tutorSupplement.mock";

export default {
  name: "CompleteModal",
  props: {
    typeTask: Number,
    task: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: 'complete'
    },
    supplementaryStudents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      file: null,
      previewImage: null,
      loading: false,
      comment: null,
      attendanceRows: [],
    }
  },
  computed: {
    isSupplementTutor() {
      return Number(this.typeTask) === 8;
    },
    isViewMode() {
      return this.mode === 'view';
    },
    isAttendanceEditMode() {
      return this.mode === 'attendance';
    },
    isCompleteMode() {
      return !this.isViewMode && !this.isAttendanceEditMode;
    },
    modalTitle() {
      if (this.isAttendanceEditMode) {
        return 'Điểm danh buổi học';
      }
      if (this.isViewMode) {
        return 'Chi tiết điểm danh buổi học';
      }
      return this.isSupplementTutor ? 'Hoàn thành buổi học' : 'Hoàn thành';
    },
    disableCompleteButton() {
      return this.loading || (!this.isSupplementTutor && !this.file) || (this.isSupplementTutor && !this.attendanceRows.length);
    },
    students() {
      const students = this.supplementaryStudents.length
        ? this.supplementaryStudents
        : (this.task?.supplement_students || this.task?.detail?.students || this.task?.students || []);

      if (students.length) {
        return students;
      }

      const totalStudents = Number(this.task?.detail?.total_students || 0);

      return Array.from({ length: totalStudents }, (_, index) => ({
        id: `student-${index + 1}`,
        code: `HV${index + 1}`,
        name: `Học viên ${index + 1}`,
        attendance_status: 'present'
      }));
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('complete-modal')
    },
    openDirection() {
      this.$refs.input && this.$refs.input.click();
    },
    handleFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.file = files[0];
      this.previewImage = URL.createObjectURL(files[0]);
      e.target.value = "";
    },
    handleDeleteImage() {
      this.file = null;
      this.previewImage = null;
    },
    resetDate() {
      this.file = null;
      this.previewImage = null;
      this.loading = false;
      this.attendanceRows = [];
    },
    initAttendanceRows() {
      this.attendanceRows = this.students.map((student) => ({
        id: student.id || student.student_id || student.code || student.student_code,
        code: this.formatStudentCode(student),
        name: student.name || student.student_name,
        status: student.attendance_status === null?null: Number(student.attendance_status || student.status) === 2 ? 'absent' : 'present'
      }));
    },
    formatStudentCode(student) {
      const code = student.code ?? student.student_code ?? student.user_id;
      if (code === null || code === undefined || code === '') {
        return null;
      }

      const numericCode = Number(code);
      return Number.isFinite(numericCode) ? numericCode + 100000 : code;
    },
    markAll(status) {
      this.attendanceRows = this.attendanceRows.map((student) => ({
        ...student,
        status
      }));
    },
    async submitAttendance() {
      if (this.isAttendanceEditMode) {
        await this.updateAttendance();
        return;
      }
      await this.completeTask();
    },
    async updateAttendance() {
      try {
        this.loading = true;
        const idTask = this.$route.params.id;
        const formData = new FormData();
        this.attendanceRows.forEach((student, index) => {
          formData.append(`students[${index}][id]`, student.id);
          formData.append(`students[${index}][attendance_status]`, student.status === 'present' ? 1 : 2);
        });

        if (String(idTask).startsWith('SUP-')) {
          updateSupplementTutorAttendance(idTask, this.attendanceRows);
        } else {
          await this.$store.dispatch(COMPLETE_SUPPLEMENTARY_TUTOR_ATTENDANCE, { idTask, formData });
        }

        this.closeModal();
        this.$notify({
          title: 'Thành công',
          message: 'Cập nhật điểm danh thành công',
          type: 'success'
        });
        this.$emit('loadDetail');
      } catch (e) {
        this.$notify.error({
          title: 'Lỗi',
          message: 'Không thể cập nhật điểm danh'
        });
      } finally {
        this.loading = false;
      }
    },
    async completeTask() {
      try {
        this.loading = true;
        const formData = new FormData();
        if (this.file) {
          formData.append('file', this.file);
        }
        if (this.isSupplementTutor) {
          this.attendanceRows.forEach((student, index) => {
            formData.append(`students[${index}][id]`, student.id);
            formData.append(`students[${index}][attendance_status]`, student.status === 'present' ? 1 : 2);
          });
        }
        let payload = {
          idTask: this.$route.params.id,
          formData
        }
        if (this.isSupplementTutor) {
          if (String(payload.idTask).startsWith('SUP-')) {
            updateSupplementTutorAttendance(payload.idTask, this.attendanceRows);
          } else {
            await this.$store.dispatch(COMPLETE_SUPPLEMENTARY_TUTOR_ATTENDANCE, payload)
          }
        } else{
          await this.$store.dispatch(COMPLETE_DETAIL_TUTOR_TASK, payload)
        }
        this.closeModal()
        this.$notify({
          title: 'Success',
          message: 'Hoàn thành ca học thành công',
          type: 'success'
        });
        this.$emit('loadDetail')
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Đã có lỗi xẩy ra'
        });
      } finally {
        this.loading = false;
      }

    }
  },
  beforeDestroy() {
    if (this.previewImage) {
      URL.revokeObjectURL(this.previewImage);
    }
  }
}
</script>
<style scoped>
.upload-box {
  align-items: center;
  background: #F3F6F9;
  border: 1px solid #D6D5D5;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  padding: 16px;
}

.student-code {
  color: #0061A4;
  font-weight: 600;
}

.attendance-actions {
  display: inline-flex;
}

.attendance-btn {
  background: #fff;
  border: 1px solid #BFC7D4;
  color: #404752;
  font-size: 12px;
  padding: 5px 10px;
}

.attendance-btn:first-child {
  border-radius: 4px 0 0 4px;
}

.attendance-btn:last-child {
  border-left: none;
  border-radius: 0 4px 4px 0;
}

.attendance-btn.active {
  background: #0061A4;
  border-color: #0061A4;
  color: #fff;
}

.attendance-status {
  border-radius: 4px;
  display: inline-block;
  min-width: 64px;
  padding: 4px 8px;
  text-align: center;
}

.attendance-status.present {
  background: #E7F7EF;
  color: #16A34A;
}

.attendance-status.absent {
  background: #FDECEC;
  color: #B91013;
}

.delete:hover {
  color: red;
}

.delete {
  color: #0BACFB
}

.edit {
  background-color: rgba(153, 153, 153, 0); /* ban đầu trong suốt */
  transition: background-color 0.3s;
}

.edit:hover {
  background-color: rgba(153, 153, 153, 0.5); /* xám mờ 50% */
}

.icon-edit {
  display: none;
  color: #0BACFB;
  font-size: 25px;
}

.edit:hover .icon-edit {
  display: block;
  cursor: pointer;
}
</style>
